/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function RecentlyEditedEmail({ localizations, ...props }) {
  // TODO: We don't have any way to find out the name of each campaign at this
  // time, so this feature is disabled.
  const hasCampaigns = false;
  // const hasCampaigns = props.campaigns && props.campaigns.length > 0;

  return (
    <li className="slds-item">
      <div className="slds-tile">
        <h3 className="slds-truncate">
          <a href={props.url} onClick={props.onClick}>
            {props.name}
          </a>
        </h3>
        <div className="slds-tile__detail slds-text-body--small">
          <p className={classnames('slds-text-color--weak', { 'slds-m-bottom--x-small': hasCampaigns })}>
            <FormattedMessage
              id={props.modifiedByName ? 'homepage.cards.email_edited_by' : 'homepage.cards.email_edited_on'}
              values={{
                edit_date: props.modifiedDate,
                edit_time: props.modifiedDate,
                edit_name: props.modifiedByName,
              }}
            />
          </p>
          {hasCampaigns ? (
            <div className="slds-grid slds-wrap">
              <div
                className="slds-col slds-size--1-of-4 slds-text-color--weak slds-truncate"
                title={localizations['homepage.cards.campaign']}
              >
                {localizations['homepage.cards.campaign']}
              </div>
              <div className="slds-col slds-size--3-of-4 slds-truncate">List campaigns here</div>
            </div>
          ) : null}
        </div>
      </div>
    </li>
  );
}

RecentlyEditedEmail.displayName = 'Recently Edited Email';

RecentlyEditedEmail.propTypes = {
  campaigns: PropTypes.array,
  localizations: PropTypes.object,
  modifiedByName: PropTypes.string,
  modifiedDate: PropTypes.number,
  name: PropTypes.string,
  onClick: PropTypes.func,
  url: PropTypes.string,
};

RecentlyEditedEmail.defaultProps = {
  url: 'javascript:void(0);', // eslint-disable-line no-script-url
};

export default RecentlyEditedEmail;
